import path from '../util/path';

$('#grant-amount input.check-input').on('click', function(event) {
  event.preventDefault()
  let theme = [];
  $.each($('#grant-amount input.check-input:checked'), function () {
    theme.push($(this).val());
  });
  const value = theme.join(',');
  const name = $(this).attr('name');

  document.location.href = path(window.location.href, name, value);
});

$('#award-date input.check-input').on('click', function(event) {
  event.preventDefault()
  let theme = [];
  $.each($('#award-date input.check-input:checked'), function () {
    theme.push($(this).val());
  });
  const value = theme.join(',');
  const name = $(this).attr('name');

  document.location.href = path(window.location.href, name, value);
});

$('#theme-category input[name=theme]').on('click', function(event) {
  event.preventDefault()
  let theme = [];
  $.each($('#theme-category input.check-input:checked'), function () {
    theme.push($(this).val());
  });
  const value = theme.join(',');
  const name = $(this).attr('name');

  document.location.href = path(window.location.href, name, value);
});



// WEBPACK FOOTER //
// ./scripts/pages/grants.js